import React from 'react';
import { connect } from 'react-redux';
import { actions } from '../../store/index';
//import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
/*
import classNames from 'classnames';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Add from '@material-ui/icons/Add';
import SvgIcon from '@material-ui/core/SvgIcon';
import Button from '@material-ui/core/Button';
import Card, { CardHeader } from '@material-ui/core/Card';
import Table, { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core/Table';
import LoadingCard from '../../components/Layout/LoadingCard';
*/
import cyan from '@material-ui/core/colors/cyan';
import amber from '@material-ui/core/colors/amber';
import purple from '@material-ui/core/colors/purple';
import Content from '../../components/Content';
import { DocumentSearch } from '../SearchTables';



const styles = theme => ({
	gridRoot: {
		flexGrow: 1,
		width: '100%',
	},
	flex: {
		flex: 1,
	},
	cardWrapper: {
		width: '100%',
		height: 350,
	},
	card: {
		color: '#ffffff',
		overflow: 'auto',
	},
	recent: {
		background: cyan[ 600 ],
	},
	due: {
		background: amber[ 600 ],
	},
	updated: {
		background: purple[ 600 ],
	},
	cardHeader: {
		color: '#ffffff',
	},
});



class SalesOrders extends React.PureComponent {

	state = {
		readyone: false,
		readytwo: false,
		readythree: false,
	};

	componentDidMount = () => {
		this.props.setTitle( 'Sales Orders: Overview' );
		setTimeout( () => {
			this.setState( { readyone: true } );
		}, 1000 );
		setTimeout( () => {
			this.setState( { readytwo: true } );
		}, 1200 );
		setTimeout( () => {
			this.setState( { readythree: true } );
		}, 1400 );
	};


	render() {
		//const classes = this.props.classes;
		//const cardHeaderClasses = {title: classes.cardHeader, subheader: classes.cardHeader};

		return <Content><DocumentSearch /></Content>;
		/*
				return (
					<Content showToolbar>
						<Toolbar>
							<Typography variant="h6" color="inherit" className={classes.flex}>
								Sales Orders
							</Typography>
							<Button color={'primary'}><SvgIcon><Add /></SvgIcon>New Sales Order</Button>
						</Toolbar>
						<Grid container className={classes.gridRoot}>


							<Grid item xs={12}>
								<Grid container justify={'center'} spacing={16}>
									<Grid item xs={12} lg={4}>

										<LoadingCard isReady={this.state.readyone} className={classes.cardWrapper}>
											<Card className={classNames(classes.card, classes.due, classes.cardWrapper)}>
												<CardHeader
													classes={cardHeaderClasses}
													title="Invoiced"
													subheader="Recently Invoiced Sales Orders"
												/>
												<Table>
													<TableHead classes={{root: classes.cardHeader}}>
														<TableRow>
															<TableCell numeric>SO#</TableCell>
															<TableCell>Business Partner</TableCell>
															<TableCell>Created</TableCell>
															<TableCell numeric>Amount</TableCell>
														</TableRow>
													</TableHead>
													<TableBody classes={{root: classes.cardHeader}}>
														<TableRow>
															<TableCell numeric>{2556}</TableCell>
															<TableCell>CateCo</TableCell>
															<TableCell>09-20-2017</TableCell>
															<TableCell numeric>{1537.88}</TableCell>
														</TableRow>
														<TableRow>
															<TableCell numeric>{2613}</TableCell>
															<TableCell>DogeLand LLC</TableCell>
															<TableCell>09-22-2017</TableCell>
															<TableCell numeric>{20167.09}</TableCell>
														</TableRow>
														<TableRow>
															<TableCell numeric>{2556}</TableCell>
															<TableCell>Mlemmers GmbH</TableCell>
															<TableCell>09-18-2017</TableCell>
															<TableCell numeric>{20.42}</TableCell>
														</TableRow>
													</TableBody>
												</Table>
											</Card>
										</LoadingCard>
									</Grid>
									<Grid item xs={12} lg={4}>
										<LoadingCard isReady={this.state.readytwo} className={classes.cardWrapper}>
											<Card className={classNames(classes.card, classes.recent, classes.cardWrapper)}>
												<CardHeader
													classes={cardHeaderClasses}
													title="New"
													subheader="Recently Created Sales Orders"
												/>
												<Table>
													<TableHead classes={{root: classes.cardHeader}}>
														<TableRow>
															<TableCell numeric>SO#</TableCell>
															<TableCell>Business Partner</TableCell>
															<TableCell>Created</TableCell>
															<TableCell numeric>Amount</TableCell>
														</TableRow>
													</TableHead>
													<TableBody classes={{root: classes.cardHeader}}>
														<TableRow>
															<TableCell numeric>{2556}</TableCell>
															<TableCell>CateCo</TableCell>
															<TableCell>09-20-2017</TableCell>
															<TableCell numeric>{1537.88}</TableCell>
														</TableRow>
														<TableRow>
															<TableCell numeric>{2613}</TableCell>
															<TableCell>DogeLand LLC</TableCell>
															<TableCell>09-22-2017</TableCell>
															<TableCell numeric>{20167.09}</TableCell>
														</TableRow>
														<TableRow>
															<TableCell numeric>{2556}</TableCell>
															<TableCell>Mlemmers GmbH</TableCell>
															<TableCell>09-18-2017</TableCell>
															<TableCell numeric>{20.42}</TableCell>
														</TableRow>
													</TableBody>
												</Table>
											</Card>
										</LoadingCard>
									</Grid>
									<Grid item xs={12} lg={4}>
										<LoadingCard isReady={this.state.readythree} className={classes.cardWrapper}>
											<Card className={classNames(classes.card, classes.updated, classes.cardWrapper)}>
												<CardHeader
													classes={cardHeaderClasses}
													title="Quotes"
													subheader="Recently Created Quotes"
												/>
												<Table>
													<TableHead classes={{root: classes.cardHeader}}>
														<TableRow>
															<TableCell numeric>SO#</TableCell>
															<TableCell>Business Partner</TableCell>
															<TableCell>Created</TableCell>
															<TableCell numeric>Amount</TableCell>
														</TableRow>
													</TableHead>
													<TableBody classes={{root: classes.cardHeader}}>
														<TableRow>
															<TableCell numeric>{2556}</TableCell>
															<TableCell>CateCo</TableCell>
															<TableCell>09-20-2017</TableCell>
															<TableCell numeric>{1537.88}</TableCell>
														</TableRow>
														<TableRow>
															<TableCell numeric>{2613}</TableCell>
															<TableCell>DogeLand LLC</TableCell>
															<TableCell>09-22-2017</TableCell>
															<TableCell numeric>{20167.09}</TableCell>
														</TableRow>
														<TableRow>
															<TableCell numeric>{2556}</TableCell>
															<TableCell>Mlemmers GmbH</TableCell>
															<TableCell>09-18-2017</TableCell>
															<TableCell numeric>{20.42}</TableCell>
														</TableRow>
													</TableBody>
												</Table>
											</Card>
										</LoadingCard>
									</Grid>
								</Grid>
							</Grid>


							<Grid item xs={12}>
								More tables, graphs, forms, whatever, go here.
							</Grid>

						</Grid>
					</Content>
				);
				*/
	}
}



const mapDispatchToProps = dispatch => {
	return {
		setTitle: ( title ) => {
			dispatch( actions.layout.setTitle( title ) );
		},
	}
};

SalesOrders = withStyles( styles )( SalesOrders );

export default connect( null, mapDispatchToProps )( SalesOrders );